export const Gender = [
  { key: "female", label: "Female" },
  { key: "male", label: "Male" },
  { key: "other", label: "Other" }
]

export const getGenderName = (key: number | string | null) => {
  const genderByKey = Gender.find(item => item.key === key)
  return genderByKey ? genderByKey.label : "N/A"
}

export const Title = [
  { key: "mr.", label: "Mr." },
  { key: "mrs.", label: "Mrs." },
  { key: "miss", label: "Miss" },
  { key: "ms.", label: "Ms." },
  { key: "mx.", label: "Mx." },
  { key: "dr.", label: "Dr." },
  { key: "prof.", label: "Prof." },
  { key: "sir", label: "Sir" }
]

export const getTitleName = (key: number | string | null) => {
  const titleByKey = Title.find(item => item.key === key)
  return titleByKey ? titleByKey.label : "N/A"
}
